/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { fetchActionsList } from "./fetchData";
import { Dropdown } from "primereact/dropdown";
import { convertDateToEpochUTC } from "../../../../helper/DateConverters";
import { fetchAllPreUseEquipmentCheckForm } from "../Equipment Checklist form/fetchData";
import { fetchAllConfinedSpacesEquipmentChecklistForm } from "../Confined Spaces Equipment form/fetchData";
import { fetchAllPermitSpaceEntryChecklistForm } from "../Permit Confined Space Entry Form/fetchData";
import { defaultFormValues as defaultEquipmentChecklistValues } from "../Equipment Checklist form/defaultFormValues";
import { defaultFormValues as defaultConfinedSpaceFormvalues } from "../Confined Spaces Equipment form/defaultFormvalues";
import { defaultFormValues as defaultPermitSpacesFormValues } from "../Permit Confined Space Entry Form/defaultFormValues";

const RiskAssessmentAndControls = ({
  toast,
  formValues,
  setFormValues,
  isUploadInProgress,
  setShowEquipmentFormPopup,
  setShowConfinedSpaceFormPopup,
  setShowPermitSpaceFormPopup,
  setAddEquipmentFormValues,
  setAddConfinedSpacesEquipmentFormValues,
  setAddPermitSpaceFormValues,
  setIsEquipmentFormAttached,
  setIsConfinedSpaceFormAttached,
  setIsPermitSpaceFormAttached,
  setConfinedSpaceFileValues,
  setConfinedSpaceTimeStampValues,
  setPermitSpaceFileValues,
  setPermitSpaceTimeStampValues,
  setSignatureDataURLs,
  firstRef,
  secondRef,
  additionalMemberRefs,
  setSelectedNames,
  setSelectedDescriptionOfSurveySite,
  setSelectedPurposeOfEntry,
  setSelectedPermitClosureReason,
}: any) => {
  const [formListsLoading, setFormListsLoading] = useState<boolean>(false);

  const [actionsList, setActionsList] = useState<any>([]);
  const [equipmentFormList, setEquipmentFormList] = useState<any>([]);
  const [confinedSpaceFormList, setConfinedSpaceFormList] = useState<any>([]);
  const [permitSpaceFormList, setPermitSpaceFormList] = useState<any>([]);

  const filters = {
    startDate: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
    endDate: convertDateToEpochUTC(
      new Date(new Date().setHours(23, 59, 59, 999))
    ),
  };

  const [selectedPreUseInspectionForm, setSelectedPreUseInspectionForm] =
    useState<any>(null);
  const [selectedConfinedSpaceForm, setSelectedConfinedSpaceForm] =
    useState<any>(null);
  const [selectedPermitSpaceForm, setSelectedPermitSpaceForm] =
    useState<any>(null);

  const allUserIDs = [
    ...(formValues.teamMember1?.userID ? [formValues.teamMember1.userID] : []),
    ...(formValues.teamMember2?.userID ? [formValues.teamMember2.userID] : []),
    ...formValues.additionalTeamMembers.map((member: any) => member.userID),
  ];

  useEffect(() => {
    fetchAllPreUseEquipmentCheckForm(
      setEquipmentFormList,
      setFormListsLoading,
      filters,
      toast,
      allUserIDs
    );
    fetchAllConfinedSpacesEquipmentChecklistForm(
      setConfinedSpaceFormList,
      setFormListsLoading,
      filters,
      toast,
      allUserIDs
    );
    fetchAllPermitSpaceEntryChecklistForm(
      setPermitSpaceFormList,
      setFormListsLoading,
      filters,
      toast,
      allUserIDs
    );
  }, [
    formValues?.teamMember1?.userID,
    formValues?.teamMember2?.userID,
    formValues?.additionalTeamMembers,
  ]);

  useEffect(() => {
    fetchActionsList(setActionsList, toast);
  }, []);

  // Function to get actions for a particular risk element
  const getActionsForRiskElement = (actionMaster: string) => {
    const actionMasterData = actionsList.find(
      (item: any) => item.actionMaster === actionMaster
    );
    return actionMasterData ? actionMasterData.actions : [];
  };

  return (
    <div>
      <div className="tw-overflow-x-auto tw-mt-4">
        <DataTable
          value={formValues?.startWorkAssessment?.checklist}
          className="tw-min-w-[600px] sm:tw-min-w-full"
          showGridlines
        >
          <Column
            field="label"
            header="3.1 Start Work Assessment"
            style={{ maxWidth: "500px" }}

            headerClassName="tw-text-sm sm:tw-text-base"
            bodyClassName="tw-text-xs sm:tw-text-sm"
          ></Column>
          <Column
            header="Yes"
            
            body={(rowData, { rowIndex }) => (
              <div className="tw-flex tw-items-center tw-gap-2">
                <RadioButton
                  inputId={`pass${rowIndex}`}
                  name={`status${rowIndex}`}
                  checked={
                    formValues?.startWorkAssessment?.checklist[rowIndex]
                      .value === true
                  }
                  disabled={isUploadInProgress}
                  onChange={() => {
                    if (
                      formValues?.startWorkAssessment?.checklist[rowIndex]
                        .name === "confinedSpaceEntryPermit"
                    ) {
                      setSignatureDataURLs({
                        firstRef: firstRef.current?.toDataURL() || "",
                        secondRef: secondRef.current?.toDataURL() || "",
                        additionalRefs: additionalMemberRefs.map(
                          (ref: any) => ref.current?.toDataURL() || ""
                        ),
                      });
                    }
                    setFormValues((prev: any) => ({
                      ...prev,
                      startWorkAssessment: {
                        ...prev.startWorkAssessment,
                        checklist: prev.startWorkAssessment.checklist.map(
                          (item: any, index: number) => {
                            if (index === rowIndex) {
                              return { ...item, value: true };
                            }
                            return item;
                          }
                        ),
                      },
                    }));
                  }}
                  className="lg:tw-w-[100px]"
                />
                {/* Show button only for pre-use inspection question when Yes is selected */}
                {rowData.name === "preUseInspection" &&
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  true && (
                    <>
                      <Button
                        label={`${selectedPreUseInspectionForm
                            ? "Open Form"
                            : "Fill New Form"
                          }`}
                        size="small"
                        className="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-text-xs tw-rounded focus:tw-shadow-none hover:tw-bg-blue-600"
                        onClick={() => setShowEquipmentFormPopup(true)}
                        disabled={isUploadInProgress}
                      />
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                        {/* <label htmlFor="attachPreUseInspection">
                            Select a Form
                          </label> */}
                        <Dropdown
                          id="attachPreUseInspection"
                          placeholder="Attach Form"
                          value={selectedPreUseInspectionForm ?? null}
                          onChange={(e) => {
                            if (e.value) {
                              setSelectedPreUseInspectionForm(e.value);
                              setFormValues((prev: any) => ({
                                ...prev,
                                preUseEquipmentCheckListFormID: e.value.id,
                              }));
                              setAddEquipmentFormValues(e.value.formJson);
                              setIsEquipmentFormAttached(true);
                            } else {
                              // Removed setting preUseEquipmentCheckListFormID as requested
                              setFormValues((prev: any) => {
                                const {
                                  preUseEquipmentCheckListFormID,
                                  ...rest
                                } = prev;
                                return rest;
                              });
                              setAddEquipmentFormValues(
                                defaultEquipmentChecklistValues
                              );
                              setIsEquipmentFormAttached(false);
                              setSelectedPreUseInspectionForm(null);
                            }
                          }}
                          disabled={formListsLoading || isUploadInProgress}
                          loading={formListsLoading || isUploadInProgress}
                          options={equipmentFormList || []}
                          optionLabel="site"
                          showClear
                          // filterBy="name"
                          filter
                          type="text"
                          className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                        />
                      </div>
                    </>
                  )}

                {rowData.name === "confinedSpaceEntryTraining" &&
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  true && (
                    <>
                      <Button
                        label={`${selectedConfinedSpaceForm
                            ? "Open Form"
                            : "Fill New Form"
                          }`}
                        size="small"
                        className="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-text-xs tw-rounded focus:tw-shadow-none hover:tw-bg-blue-600"
                        onClick={() => setShowConfinedSpaceFormPopup(true)}
                        disabled={isUploadInProgress}
                      />
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                        {/* <label htmlFor="attachPreUseInspection">
                            Select a Form
                          </label> */}
                        <Dropdown
                          id="attachPreUseInspection"
                          placeholder="Attach Form"
                          value={selectedConfinedSpaceForm ?? null}
                          onChange={(e) => {
                            if (e.value) {
                              setSelectedConfinedSpaceForm(e.value);
                              setFormValues((prev: any) => ({
                                ...prev,
                                preUseConfinedSpaceEquipmentFormID: e.value.id,
                              }));
                              setConfinedSpaceFileValues(e.value.fileJson);
                              setConfinedSpaceTimeStampValues(
                                e.value.timeStampLocationJson
                              );
                              setAddConfinedSpacesEquipmentFormValues(
                                e.value.formJson
                              );
                              setIsConfinedSpaceFormAttached(true);
                            } else {
                              // Removed setting preUseConfinedSpaceEquipmentFormID as requested
                              setFormValues((prev: any) => {
                                const {
                                  preUseConfinedSpaceEquipmentFormID,
                                  ...rest
                                } = prev;
                                return rest;
                              });
                              setAddConfinedSpacesEquipmentFormValues(
                                defaultConfinedSpaceFormvalues
                              );
                              setIsConfinedSpaceFormAttached(false);
                              setSelectedConfinedSpaceForm(null);
                            }
                          }}
                          disabled={formListsLoading || isUploadInProgress}
                          loading={formListsLoading || isUploadInProgress}
                          options={confinedSpaceFormList || []}
                          optionLabel="site"
                          // filterBy="name"
                          showClear
                          filter
                          type="text"
                          className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                        />
                      </div>
                    </>
                  )}

                {rowData.name === "confinedSpaceEntryPermit" &&
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  true && (
                    <>
                      {" "}
                      <Button
                        label={`${selectedPermitSpaceForm
                            ? "Open Form"
                            : "Fill New Form"
                          }`}
                        size="small"
                        className="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-text-xs tw-rounded focus:tw-shadow-none hover:tw-bg-blue-600"
                        onClick={() => {
                          setSignatureDataURLs({
                            firstRef: firstRef.current?.toDataURL() || "",
                            secondRef: secondRef.current?.toDataURL() || "",
                            additionalRefs: additionalMemberRefs.map(
                              (ref: any) => ref.current?.toDataURL() || ""
                            ),
                          });
                          setShowPermitSpaceFormPopup(true);
                        }}
                        disabled={isUploadInProgress}
                      />
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                        {/* <label htmlFor="attachPreUseInspection">
                            Select a Form
                          </label> */}
                        <Dropdown
                          id="attachPreUseInspection"
                          placeholder="Attach Form"
                          value={selectedPermitSpaceForm ?? null}
                          onChange={(e) => {
                            if (e.value) {
                              setSelectedPermitSpaceForm(e.value);
                              setFormValues((prev: any) => ({
                                ...prev,
                                permitConfinedSpaceEntryFormID: e.value.id,
                              }));
                              setPermitSpaceFileValues(e.value.fileJson);
                              setAddPermitSpaceFormValues(e.value.formJson);
                              setPermitSpaceTimeStampValues(
                                e.value.timeStampLocationJson
                              );
                              setIsPermitSpaceFormAttached(true);
                            } else {
                              setSelectedNames(null);
                              setSelectedDescriptionOfSurveySite(null);
                              setSelectedPurposeOfEntry(null);
                              setSelectedPermitClosureReason(null);
                              // Removed setting permitConfinedSpaceEntryFormID as requested
                              setFormValues((prev: any) => {
                                const {
                                  permitConfinedSpaceEntryFormID,
                                  ...rest
                                } = prev;
                                return rest;
                              });
                              setAddPermitSpaceFormValues(
                                defaultPermitSpacesFormValues
                              );
                              setIsPermitSpaceFormAttached(false);
                              setSelectedPermitSpaceForm(null);
                            }
                          }}
                          disabled={formListsLoading || isUploadInProgress}
                          loading={formListsLoading || isUploadInProgress}
                          options={permitSpaceFormList || []}
                          optionLabel="site"
                          // filterBy="name"
                          showClear
                          filter
                          type="text"
                          className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-10 sm:tw-h-11 tw-w-full tw-text-sm sm:tw-text-base"
                        />
                      </div>
                    </>
                  )}
              </div>
            )}
          />
          <Column
            header="No"
            style={{ width: "100px" }}
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`fail${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.checklist[rowIndex].value ===
                  false
                }
                disabled={isUploadInProgress}
                onChange={() => {
                  if (
                    formValues?.startWorkAssessment?.checklist[rowIndex]
                      .name === "preUseInspection"
                  ) {
                    setSelectedPreUseInspectionForm(null);
                    setFormValues((prev: any) => {
                      const { preUseEquipmentCheckListFormID, ...rest } = prev;
                      return rest;
                    });
                  } else if (
                    formValues?.startWorkAssessment?.checklist[rowIndex]
                      .name === "confinedSpaceEntryTraining"
                  ) {
                    setSelectedConfinedSpaceForm(null);
                    setFormValues((prev: any) => {
                      const { preUseConfinedSpaceEquipmentFormID, ...rest } =
                        prev;
                      return rest;
                    });
                  } else if (
                    formValues?.startWorkAssessment?.checklist[rowIndex]
                      .name === "confinedSpaceEntryPermit"
                  ) {
                    setSelectedNames(null);
                    setSelectedDescriptionOfSurveySite(null);
                    setSelectedPurposeOfEntry(null);
                    setSelectedPermitClosureReason(null);
                    setSelectedPermitSpaceForm(null);
                    setFormValues((prev: any) => {
                      const { permitConfinedSpaceEntryFormID, ...rest } = prev;
                      return rest;
                    });
                  }
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      checklist: prev.startWorkAssessment.checklist.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: false };
                          }
                          return item;
                        }
                      ),
                    },
                  }));
                }}
                className="lg:tw-w-[100px]"
              />
            )}
          />
        </DataTable>
      </div>
      <div className="tw-text-[#5B5B5B] tw-text-sm tw-mt-4 tw-px-4">
        {/* <span className="tw-text-[#F00]">Notes:  </span> */}
        <span className="tw-text-[#F00]">
          If you have answered "no" to any of the above questions, contact your
          supervisor immediately. You must not continue until you have been
          instructed to by him/her.
        </span>
      </div>
      <div className="tw-overflow-x-auto tw-mt-4">
        <DataTable
          value={formValues?.startWorkAssessment?.riskelements}

          showGridlines
        >
          <Column
            field="label"
            header="3.2 Risk Element"
            style={{ maxWidth: "500px" }}
            headerClassName="tw-text-sm sm:tw-text-base"
            bodyClassName="tw-text-xs sm:tw-text-sm"
          ></Column>
          <Column
            header="Yes"
            
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`pass${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.riskelements[rowIndex]
                    .value === true
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      riskelements: prev.startWorkAssessment.riskelements.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return { ...item, value: true };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />
          <Column
            header="No" style={{ maxWidth: "100px" }}
            body={(rowData, { rowIndex }) => (
              <RadioButton
                inputId={`fail${rowIndex}`}
                name={`status${rowIndex}`}
                checked={
                  formValues?.startWorkAssessment?.riskelements[rowIndex]
                    .value === false
                }
                disabled={isUploadInProgress}
                onChange={() =>
                  setFormValues((prev: any) => ({
                    ...prev,
                    startWorkAssessment: {
                      ...prev.startWorkAssessment,
                      riskelements: prev.startWorkAssessment.riskelements.map(
                        (item: any, index: number) => {
                          if (index === rowIndex) {
                            return {
                              ...item,
                              value: false,
                              action: null,
                            };
                          }
                          return item;
                        }
                      ),
                    },
                  }))
                }
                className="lg:tw-w-[100px]"
              />
            )}
          />
          {/* Action Dropdown Column */}
          <Column
            header="Action"
            style={{ width: "200px" }}
            body={(rowData, { rowIndex }) => {
              const riskElement =
                formValues?.startWorkAssessment?.riskelements[rowIndex];
              const actionsForRiskElement = getActionsForRiskElement(
                riskElement.name
              );

              return (
                <MultiSelect
                  id="teamMember1"
                  selectAllLabel="Select All"
                  maxSelectedLabels={1}
                  optionLabel="name"
                  placeholder="Action Taken"
                  value={riskElement.action}
                  disabled={
                    riskElement.value === false ||
                    riskElement.value === null ||
                    isUploadInProgress
                  }
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      startWorkAssessment: {
                        ...prev.startWorkAssessment,
                        riskelements: prev.startWorkAssessment.riskelements.map(
                          (item: any, index: number) => {
                            if (index === rowIndex) {
                              return { ...item, action: e.value };
                            }
                            return item;
                          }
                        ),
                      },
                    }));
                  }}
                  options={actionsForRiskElement}
                  className="tw-border tw-border-solid tw-rounded-full tw-px-2 placeholder:tw-font-normal filter-dropdown"
                />
              );
            }}
          />
        </DataTable>
      </div>
      <div className="tw-text-[#5B5B5B] tw-text-sm tw-mt-4 tw-px-4">
        {/* <span className="tw-text-[#F00]">Notes:  </span> */}
        <span className="tw-text-[#F00]">
          The assessment must be discussed and agreed with all other team
          members who must sign below to confirm they understand and that the
          works area, plant and equipment are safe, and works can proceed
          safely.
        </span>
      </div>
    </div>
  );
};

export default RiskAssessmentAndControls;
